import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CreateOpportunityPageData } from './interface';

@Injectable()
export class CreateOpportunityService {
  private readonly createPageDetails$$ = new BehaviorSubject<CreateOpportunityPageData>(null);
  public readonly createPageDetails$ = this.createPageDetails$$.asObservable();

  setCreatePageDetails(data: CreateOpportunityPageData): void {
    this.createPageDetails$$.next(data);
  }
}
